import { Component, Inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

export interface TaskApprovalResultBottomSheetData {
  isApproved: boolean;
}

@Component({
  selector: 'task-approval-result-bottom-sheet',
  imports: [MatButtonModule, TranslocoDirective],
  templateUrl: './task-approval-result-bottom-sheet.html',
  styleUrl: './task-approval-result-bottom-sheet.scss',
})
export class TaskApprovalResultBottomSheet {
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<TaskApprovalResultBottomSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly data: TaskApprovalResultBottomSheetData,
  ) {}

  returnToList(): void {
    this.bottomSheetRef.dismiss(true);
  }
}
